import 'whatwg-fetch';
import { Loader } from '../common/sysco-ui-components/services/commonServices';
import { DP_ENV } from '../config/apiConfig';
import Axios from 'axios';
import { toast } from "react-toastify";
/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */
function parseJSON(response) {
  Loader(false)
  if (response.status === 204 || response.status === 205) {
    return null;
  }
  return response.json();
}

/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */
async function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  const error = new Error(response.status);
  Loader(false);
  error.response = response;
  throw error;
}

/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */
export default function request(url, options) {

  if (url.includes("token")) {
    Loader(true);
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON);
  }

  const suppressLoader =
    url.includes("get-vendor-download-links") ||
    url.includes("get-recent-check") ||
    url.includes("daily-pending-payable-report");

  if (!suppressLoader) Loader(true);
  else Loader(false);

  const perform = async () => {
    let res = await fetch(url, options);
    return res;
  };

  return perform()
    .then(checkStatus)
    .then(parseJSON);
}

export function generateApigeeErrorMsg(status, error) {
  let errorMessage = `Server call failed. Please try again and re-login if the problem persists.\n 
                      Technical details: Status: ${status}, Error: ${error}`

  return errorMessage
}